

export const usernameregex =/^[A-Za-z0-9]+$/;
export const teacherusernameregex =/^[A-Za-z0-9]+$/;

export const emailregex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const mobileregex = /^\d{10}$/

export const pincoderegex = /^\d{6}$/
export const nameregex = /^[A-Za-z\s]{2,20}$/;
export const cityregex = /^[a-zA-Z0-9\-',&@ ]{3,100}$/
export const subjectNameRegex = /^[A-Za-z0-9\s]{2,25}$/;
export const nationalitynameregex = /^[A-Za-z\s]{2,15}$/; // Alphabets and spaces, 2 to 9 characters
export const religionnameregex = /^[A-Za-z\s]{2,15}$/; // Alphabets and spaces, 2 to 9 characters
// Title: Minimum 3 characters, alphabets, spaces, and numbers
export const titleRegex = /^[A-Za-z0-9\s]{3,}$/;
// Description: Minimum 3 characters, alphabets, spaces, numbers, and common punctuation
export const descriptionRegex = /^[A-Za-z0-9\s.,?!'"\-]{3,}$/;

export const expregex = /^(0|[1-9]|[1-3][0-9]|40)$/

export const aadharregex = /^\d{12}$/

export const rollNoRegex = /^(?:[1-9]|[1-9][0-9]{1,2}|999)$/
export const educationRegex = /^[a-zA-Z0-9\s,'&()\-/.]{2,100}$/
export const ocupationregex = /^[a-zA-Z\s,'&()\-/.]{2,100}$/

export const standardNameRegex = /^[A-Za-z\s]{3,}$/;
export const sectionRegex = /^[A-Za-z\s]$/;
export const chapterRegex = /^[A-Za-z0-9\s]{2,20}$/;
export const dairynoteRegex = /^[A-Za-z0-9\s]{10,}$/;
export const holidayRegex = /^[A-Za-z0-9\s]{2,20}$/;
export const imageUrlRegex =
  /^(https?:\/\/.*\.(?:png|jpg|jpeg|webp|gif))$/i;

  export const sessionRegex = /^\d{4}-\d{4}$/;



export const loadingTime = 500


export const  isValidDateOfBirth =(value:string) =>{
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    
    if (!dateRegex.test(value)) {
        return false; // Invalid date format
    }

    const today = new Date();
    const birthDate = new Date(value);

    // Calculate age based on year difference
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age >= 18;
}

export const  isValidStudentDateOfBirth =(value:string) =>{
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    
    if (!dateRegex.test(value)) {
        return false; // Invalid date format
    }

    const today = new Date();
    const birthDate = new Date(value);

    // Calculate age based on year difference
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age >= 2;
}